import { PageSEO } from "@/components/SEO";

const PrivacyPage = () => (
  <main data-testid="privacy-page" className="pt-20">
    <PageSEO title="Privacy Notice" description="Privacy notice for The Lemonade Living Company. How we collect, use, and protect your personal information." path="/privacy" />
    <section className="py-16 md:py-24">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <p className="text-xs tracking-[0.3em] uppercase mb-4" style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}>Legal</p>
        <h1 className="font-serif text-4xl sm:text-5xl font-light mb-8" style={{ color: "var(--ll-text)" }}>Privacy Notice</h1>
        <p className="text-xs mb-12" style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}>Last updated: February 2026</p>

        <div className="prose-custom space-y-8">
          <Section title="1. Who We Are">
            The Lemonade Living Company (&ldquo;we&rdquo;, &ldquo;us&rdquo;, &ldquo;our&rdquo;) is a South African wellness company providing digital and physical wellness products, courses, and tools. We are committed to protecting your personal information in accordance with the Protection of Personal Information Act (POPIA) and applicable data protection laws.
          </Section>

          <Section title="2. Information We Collect">
            We collect the following personal information when you interact with our website:
            {"\n\n"}
            <strong>Information you provide:</strong> Name, email address, and payment details when you make a purchase, download free resources, join a waitlist, or submit a contact form.
            {"\n\n"}
            <strong>Automatically collected:</strong> Browser type, device information, IP address, and general location (timezone) for currency display purposes. We do not track your precise location.
          </Section>

          <Section title="3. How We Use Your Information">
            We use your personal information to:
            {"\n"}
            &bull; Process purchases and deliver digital products{"\n"}
            &bull; Send you the free resources you request{"\n"}
            &bull; Notify you about products you&apos;ve waitlisted{"\n"}
            &bull; Respond to enquiries submitted via our contact form{"\n"}
            &bull; Send order confirmations and download links via email{"\n"}
            &bull; Improve our website and product offerings
          </Section>

          <Section title="4. Payment Processing">
            All payments are processed securely through PayFast, a PCI DSS-compliant payment gateway based in South Africa. We do not store your credit card or banking details on our servers. Please refer to PayFast&apos;s privacy policy for details on how they handle your payment information.
          </Section>

          <Section title="5. Email Communications">
            When you download a free resource or make a purchase, we send transactional emails (download links, order confirmations) via Resend. We may occasionally send you information about new products relevant to your interests. You can unsubscribe from marketing emails at any time by contacting us directly.
          </Section>

          <Section title="6. Data Sharing">
            We do not sell, rent, or share your personal information with third parties for marketing purposes. We share data only with:
            {"\n"}
            &bull; PayFast (payment processing){"\n"}
            &bull; Resend (email delivery){"\n"}
            &bull; Our hosting provider (for website operation)
          </Section>

          <Section title="7. Data Security">
            We implement appropriate technical and organisational measures to protect your personal information against unauthorised access, alteration, disclosure, or destruction. All data is transmitted over encrypted HTTPS connections.
          </Section>

          <Section title="8. Your Rights (POPIA)">
            Under the Protection of Personal Information Act, you have the right to:
            {"\n"}
            &bull; Request access to the personal information we hold about you{"\n"}
            &bull; Request correction of inaccurate information{"\n"}
            &bull; Request deletion of your personal information{"\n"}
            &bull; Object to the processing of your personal information{"\n"}
            &bull; Lodge a complaint with the Information Regulator{"\n\n"}
            To exercise any of these rights, contact us at lemonadeliving4me@gmail.com.
          </Section>

          <Section title="9. Cookies">
            Our website uses essential cookies required for basic functionality (session management, preferences). We do not use third-party tracking cookies or advertising cookies.
          </Section>

          <Section title="10. Changes to This Notice">
            We may update this privacy notice from time to time. Any changes will be posted on this page with an updated revision date. We encourage you to review this notice periodically.
          </Section>

          <Section title="11. Contact Us">
            If you have any questions about this privacy notice or how we handle your data, please contact us at:
            {"\n\n"}
            <strong>The Lemonade Living Company</strong>{"\n"}
            Email: lemonadeliving4me@gmail.com{"\n"}
            Location: South Africa
          </Section>
        </div>
      </div>
    </section>
  </main>
);

const Section = ({ title, children }) => (
  <div>
    <h2 className="font-serif text-lg font-medium mb-3" style={{ color: "var(--ll-text)" }}>{title}</h2>
    <p className="text-sm leading-relaxed whitespace-pre-line" style={{ color: "var(--ll-text-secondary)", fontFamily: "'Outfit', sans-serif" }}>
      {children}
    </p>
  </div>
);

export default PrivacyPage;
